/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Feature_DescInputs */

const en_mk_tb_feature_desc = /** @type {(inputs: Mk_Tb_Feature_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share scope, assign owners, claim tasks, hand off context and review progress together.`)
};

const id_mk_tb_feature_desc = /** @type {(inputs: Mk_Tb_Feature_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagikan lingkup, tentukan penanggung jawab, ambil tugas, serahkan konteks, dan tinjau progres bersama.`)
};

/**
* | output |
* | --- |
* | "Share scope, assign owners, claim tasks, hand off context and review progress together." |
*
* @param {Mk_Tb_Feature_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_feature_desc = /** @type {((inputs?: Mk_Tb_Feature_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Feature_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_feature_desc(inputs)
	return en_mk_tb_feature_desc(inputs)
});